/**
 * ⚠️  AI 指引：所有前端使用者可見的錯誤訊息必須集中定義於此檔案。
 *   - 不要在元件或 hooks 內直接硬編碼中文／英文錯誤字串
 *   - 新增錯誤訊息時，請在對應分類下加入常數
 *   - 命名規則：[模組]_[情境]，例如 AUTH_WEBAUTHN_NOT_SUPPORTED
 *   - 表單驗證（必填欄位未填）可保留在元件內 inline 顯示
 *   - 所有 API 錯誤、系統錯誤請透過 useToast 呼叫此檔案的常數顯示
 */
export const ERR = {
  // ── 通用 ────────────────────────────────────────────────────────────────
  GENERIC: '發生錯誤，請稍後再試',

  // ── 驗證 / Auth ──────────────────────────────────────────────────────────
  AUTH_WEBAUTHN_NOT_SUPPORTED: '此裝置不支援 WebAuthn，請改用可支援裝置',
  AUTH_PASSKEY_REGISTER_FAILED: 'Passkey 註冊失敗',
  AUTH_MAGIC_LINK_FAILED: '登入連結驗證失敗',
  AUTH_LOGIN_FAILED: '登入失敗',
  AUTH_SEND_FAILED: '寄送登入連結失敗',
  AUTH_REGISTER_FAILED: '註冊失敗，請稍後再試',
  AUTH_EMAIL_EXISTS: '此電子郵件已被使用',
  AUTH_REGISTRATION_CLOSED: '目前不開放新用戶註冊',

  // ── 支出 / Expense ───────────────────────────────────────────────────────
  EXPENSE_DELETE_FAILED: '刪除支出失敗',
  EXPENSE_LOAD_FAILED: '載入支出資料失敗',
  EXPENSE_SAVE_FAILED: '儲存支出失敗',

  // ── 結算 / Settlement ────────────────────────────────────────────────────
  SETTLEMENT_FAILED: '結算操作失敗',

  // ── 成員 / Member ────────────────────────────────────────────────────────
  MEMBER_INVITE_FAILED: '邀請成員失敗',
  MEMBER_REMOVE_FAILED: '移除成員失敗',
  MEMBER_SEARCH_FAILED: '搜尋成員失敗',

  // ── 帳戶 / Bank Account ──────────────────────────────────────────────────
  ACCOUNT_SAVE_FAILED: '帳戶儲存失敗',
  ACCOUNT_DELETE_FAILED: '帳戶刪除失敗',

  // ── 群組 / Group ─────────────────────────────────────────────────────────
  GROUP_LOAD_FAILED: '載入群組資訊失敗',
  GROUP_UPDATE_FAILED: '更新群組失敗',

  // ── 系統管理 / System Admin ──────────────────────────────────────────────
  ADMIN_SETTINGS_LOAD_FAILED: '載入系統設定失敗',
  ADMIN_SETTINGS_SAVE_FAILED: '儲存系統設定失敗',
} as const;

export type ErrKey = keyof typeof ERR;
